export const isFullStatic = false
export const staticPath = "/var/www/rahalaitos-v2/releases/134/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"